import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * `/admin/branding` — la pagina del branding con la scelta dell'azienda, tolta il 02-11-2026: il
 * branding si fa da «Organizzazione» › «Dati dell'azienda», sezione «Aspetto» (quello di una
 * controllata, aprendola da «Aziende collegate»). L'indirizzo resta come rinvio, per i preferiti e
 * i collegamenti salvati.
 */
export const Route = createFileRoute('/_app/admin/branding')({
  beforeLoad: () => { throw redirect({ to: '/organization/company-data', search: { section: 'branding' }, replace: true }); },
});
